/**
 * Day 1, and the single source of truth for it.
 *
 * The game maps a calendar date to a day number from this, and the curator
 * copies it into public/daily.json so anything else reading the schedule --
 * the newsletter's puzzle preview, for one -- resolves the same day the player
 * sees. Before this existed the preview inferred day 1 from the file's
 * generatedAt timestamp, so it read "Day 1" on the day of every re-curation
 * regardless of what the game was actually serving.
 *
 * The Monday before launch. See src/daily.ts for why the calendar starts where
 * it does rather than on the day the game shipped.
 */
export const LAUNCH_DATE = { year: 2026, month: 8, day: 17 } as const;

/** ISO date, the form written into daily.json and read back by consumers. */
export const LAUNCH_DATE_ISO = `${LAUNCH_DATE.year}-${String(LAUNCH_DATE.month).padStart(2, "0")}-${String(LAUNCH_DATE.day).padStart(2, "0")}`;
